import { render, staticRenderFns } from "./LabFreezingPointDepression.vue?vue&type=template&id=20291c49&"
import script from "./LabFreezingPointDepression.vue?vue&type=script&lang=ts&"
export * from "./LabFreezingPointDepression.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports